export interface IValidation {
    firstName: boolean,
    lastName: boolean,
    address1: boolean,
    address2: boolean,
    city: boolean,
    state: boolean,
    postalCode: boolean,
}

export interface IBulkCheekSwabState {
    firstName: string,
    lastName: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    postalCode: string,
    dirty: boolean,
    validation: IValidation
}

export const initialState: IBulkCheekSwabState = {
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    dirty: true,
    validation: {
        firstName: true,
        lastName: true,
        address1: true,
        address2: true,
        city: true,
        state: true,
        postalCode: true
    }
}

export const bulkCheekSwabReducer = (state: IBulkCheekSwabState, action: { type: string, value: any }): IBulkCheekSwabState => {
    if (action.type == 'update-firstName') {
        return { ...state, firstName: action.value };
    }

    if (action.type == 'update-lastName') {
        return { ...state, lastName: action.value };
    }

    if (action.type == 'update-address1') {
        return { ...state, address1: action.value };
    }

    if (action.type == 'update-address2') {
        return { ...state, address2: action.value };
    }

    if (action.type == 'update-city') {
        return { ...state, city: action.value };
    }

    if (action.type == 'update-state') {
        return { ...state, state: action.value };
    }

    if (action.type == 'update-postalCode') {
        return { ...state, postalCode: action.value };
    }

    if (action.type == 'after-load') {
        let { firstName, lastName, address1, address2, city, state: stateAbbr, postalCode } = action.value;
        return { ...state, firstName, lastName, address1, address2, city, state: stateAbbr, postalCode };
    }

    if (action.type == 'update-from-submit') {
        return { ...state, validation: action.value.validation, dirty: action.value.dirty };
    }

    // if (action.type == 'update-dirty') {
    //     return { ...state, dirty: action.value };
    // }

    return { ...state };
}